import React from 'react';
import styles from './InfoGraphickBlock.module.css';
import { useTranslation } from 'react-i18next';
import Label from '../../../../components/EntToEndUI/Label/Label';
import SteelTable from '../../../../components/Tables/SteelTable/SteelTable';
import Button from '../../../../components/Buttons/Button/Button';
import RequestForm from '../../../../components/EntToEndUI/RequestForm/RequestForm';

const InfoGraphickBlock = ({ title, subTitle, image, ...props }) => {
  const { t } = useTranslation();

  return (
    <section className={styles.sectionBanner}>
      <div className={styles.sectionBannerContainer}>
          <Label 
          topText={title}
          bottomText={subTitle}
          shift="medium"
          />
        
        <div className={styles.infographicContainer}>
            <img src={image} alt={title} />
        </div>
      </div>
    </section>
  );
};

export default InfoGraphickBlock; 